import Vue from 'vue'
import Vuex from 'vuex'
import Providers from './modules/providers'
import Rates from './modules/rates'
import MenuItems from './modules/menuItems'
import Contents from './modules/contents'
import AuthToken from './modules/authToken'
import Users from './modules/users'
import Roles from './modules/roles'
import Sidebars from './modules/sidebars'
import CustomerTypes from './modules/customerTypes'
import Constants from './modules/constants'
import Translations from './modules/translations'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        AuthToken,
        Contents,
        MenuItems,
        Providers,
        Rates,
        Users,
        Roles,
        Sidebars,
        CustomerTypes,
        Constants,
        Translations,
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js